/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Injectable } from '@angular/core';
import { MetaDefinition } from '@angular/platform-browser';
import { MetaTagsService } from '../meta-tags.service';

@Injectable({
  providedIn: 'root',
})
export class MetaTagsBrowserService implements MetaTagsService {
  addTag({ name, content }: MetaDefinition): void {}
  updateTag({ name, content, property }: MetaDefinition): void {}
  addTags(tagsArray: MetaDefinition[]): void {}
  setMetatags(tags: any): void {}
}
